import React, { useState } from 'react';
import { Button, Col, Row } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight, faEdit, faSave } from '@fortawesome/free-solid-svg-icons';

//Context
import { useAuth } from '../../../../context/auth';

//Componentes
import TextField from '../../../../components/TextField';

//Helpers
import { objCampo, validarCampos } from '../../../../helpers/ValidadorDeCampos';
import mascaras from '../../../../helpers/mascaras';
import solicitacaoFiscalizacao_api from '../../../../api/solicitacaoFiscalizacao_api';
import { showMessage } from '../../../../helpers/message';


function DadosDenunciante({ solicitacaoFiscalicao, setSolicitacaoFiscalicao, loadSolicitacaoFiscalizacao }) {
    //State para pegar erros
    const [errors, setErrors] = useState({});

    const { setLoading } = useAuth();

    //Estado de controle dos campos obrigatorios 
    const [campos, setCampos] = useState([
        objCampo({ name: "contatoDenuncia_Nome", required: true }),
        objCampo({ name: "contatoDenuncia_Telefone", required: true }),
        objCampo({ name: "contatoDenuncia_Email", required: true }),
        objCampo({ name: "contatoDenuncia_CPF", required: true, cpf: true })
    ]);

    //Função de onChange dos campos
    const onChange = (e) => {
        const { name, value } = e.target;
        const _solicitacaoFiscalicao = {
            ...solicitacaoFiscalicao,
            [name]: value
        }

        //Validando erros no campo especifico para checar em tempo de digitação se ele possui algum erro
        const _campos = campos.filter(campo => campo.name === name);
        const fieldError = validarCampos(_solicitacaoFiscalicao, _campos);

        const _errors = { ...errors };
        delete _errors[name];
        if (fieldError[1].length === 0)
            setErrors({ ..._errors });
        else
            setErrors({ ..._errors, ...fieldError[0] });

        setSolicitacaoFiscalicao({
            ...solicitacaoFiscalicao,
            [name]: value
        });
    }

    //Função para salvar e ir para proximos
    const handleProximo = () => {
        const _errors = validarCampos(solicitacaoFiscalicao, campos);
        setErrors(_errors[0]);

        if (_errors[1].length > 0)
            return true;

        const _solicitacaoFiscalicao = { ...solicitacaoFiscalicao };

        setLoading(true)
        solicitacaoFiscalizacao_api.put(_solicitacaoFiscalicao)
            .then(response => {
                showMessage("Sucesso", "Operação realizada com sucesso", "success", () => loadSolicitacaoFiscalizacao())
            })
            .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
            .finally(() => setLoading(false))
    }


    return <>
        <Row>
            <h5 className='mb-3'>Dados do Denunciante</h5>
            <Col md={12} lg={6}>
                <TextField
                    type={"text"}
                    name={"contatoDenuncia_Nome"}
                    label={"* Nome do Denunciante"}
                    onChange={onChange}
                    value={solicitacaoFiscalicao.contatoDenuncia_Nome}
                    invalid={!!errors.contatoDenuncia_Nome}
                    disabled={solicitacaoFiscalicao.origem == "Interna" ? false : true}
                />
            </Col>
            <Col md={12} lg={6}>
                <TextField
                    type={"text"}
                    name={"contatoDenuncia_CPF"}
                    mask={mascaras.cpfMask}
                    label={"* CPF"}
                    onChange={onChange}
                    value={solicitacaoFiscalicao.contatoDenuncia_CPF}
                    invalid={!!errors.contatoDenuncia_CPF}
                    maxLength={14}
                    disabled={solicitacaoFiscalicao.origem == "Interna" ? false : true}
                />
            </Col>
            <Col md={12} lg={6}>
                <TextField
                    type={"text"}
                    name={"contatoDenuncia_Telefone"}
                    mask={mascaras.telefoneMask}
                    label={"* Telefone"}
                    onChange={onChange}
                    value={solicitacaoFiscalicao.contatoDenuncia_Telefone}
                    invalid={!!errors.contatoDenuncia_Telefone}
                    maxLength={14}
                    disabled={solicitacaoFiscalicao.origem == "Interna" ? false : true}
                />
            </Col>
            <Col md={12} lg={6}>
                <TextField
                    type={"email"}
                    name={"contatoDenuncia_Email"}
                    label={"* Email"}
                    onChange={onChange}
                    value={solicitacaoFiscalicao.contatoDenuncia_Email}
                    invalid={!!errors.contatoDenuncia_Email}
                    disabled={solicitacaoFiscalicao.origem == "Interna" ? false : true}
                />
            </Col>
        </Row>
        <Row>
            <Col md={12} lg={12} className={`d-flex justify-content-center ${solicitacaoFiscalicao.origem == "Interna" ? "" : "d-none"}`}>
                <Button
                    color={solicitacaoFiscalicao.id ? 'warning text-white' : 'success'}
                    onClick={handleProximo}
                >
                    {solicitacaoFiscalicao.id ? <><FontAwesomeIcon icon={faEdit} /> Atualizar</> : <><FontAwesomeIcon icon={faSave} /> Salvar</>}
                </Button>
            </Col>
        </Row>
    </>;
}

export default DadosDenunciante;